// src/App.jsx
import React, { useState, useRef } from "react";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import Card from "./components/card";
import { CHAINS } from "./chains";

import dragoHeadshot from "./assets/Drago.png";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    background: radial-gradient(circle at top, #e5f0ff 0, #f7f8ff 38%, #ffffff 100%);
    color: #0f172a;
  }

  * {
    box-sizing: border-box;
  }
`;


const Page = styled.div`
  min-height: 100vh;
  padding: 20px 16px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Content = styled.div`
  width: 100%;
  max-width: 960px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

/* Heading card */

const HeadingCard = styled.section`
  width: 100%;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.18);
  padding: 16px 14px;

  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  @media (min-width: 640px) {
    padding: 18px 20px;
    flex-direction: row;
    align-items: center;
  }
`;

const HeadingImageWrapper = styled.div`
  flex-shrink: 0;
  width: 68px;
  height: 68px;
  border-radius: 20px;
  background: #1a73ff;
  box-shadow: 0 14px 28px rgba(26, 115, 255, 0.5);
  position: relative;
  overflow: hidden;
`;

const HeadingImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const HeadingText = styled.div`
  text-align: center;

  @media (min-width: 640px) {
    text-align: left;
    margin-left: 8px;
  }
`;

const HeadingTitle = styled.h1`
  margin: 0;
  font-size: 1.6rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const HeadingSubtitle = styled.p`
  margin: 6px 0 0;
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
`;

const ChainGrid = styled.div`
  display: grid;
  gap: 16px;
  margin-top: 4px;

  /* MOBILE FIRST → 2 wide */
  grid-template-columns: repeat(2, minmax(0, 1fr));

  /* TABLET → 3 wide */
  @media (min-width: 600px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  /* LARGE DESKTOP → 4 wide */
  @media (min-width: 1000px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

/* Toast */

const slideUp = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  20% {
    transform: translateY(0);
    opacity: 1;
  }
  80% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(120%);
    opacity: 0;
  }
`;

const ToastContainer = styled.div`
  position: fixed;
  left: 50%;
  bottom: 18px;
  transform: translateX(-50%);
  z-index: 999;
  pointer-events: none;
`;

const ToastBubble = styled.div`
  min-width: 260px;
  max-width: 90vw;
  padding: 10px 16px;
  border-radius: 999px;
  background: #0f172a;
  color: #f9fafb;
  font-size: 0.78rem;
  text-align: center;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(148, 163, 184, 0.7);
  animation: ${slideUp} 2.1s ease forwards;
`;

function App() {
  const [toastText, setToastText] = useState("");
  const [toastVisible, setToastVisible] = useState(false);
  const toastTimeoutRef = useRef(null);

  const handleCopy = async (chain) => {
    try {
      await navigator.clipboard.writeText(chain.address);
      const message = `COPIED ${chain.ticker.toUpperCase()} ADDRESS TO CLIPBOARD.`;

      setToastText(message);
      setToastVisible(true);

      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }

      toastTimeoutRef.current = setTimeout(() => {
        setToastVisible(false);
      }, 2000);
    } catch {
      setToastText("Unable to copy to clipboard.");
      setToastVisible(true);

      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
      toastTimeoutRef.current = setTimeout(() => {
        setToastVisible(false);
      }, 2000);
    }
  };

  return (
    <>
      <GlobalStyle />
      <Page>
        <Content>
          <HeadingCard>
            <HeadingImageWrapper>
              <HeadingImage src={dragoHeadshot} alt="Drago" />
            </HeadingImageWrapper>
            <HeadingText>
              <HeadingTitle>DRAGONMASTERDX&apos;S LOCKER</HeadingTitle>
              <HeadingSubtitle>
                Here are my wallets, send me tokens.
              </HeadingSubtitle>
            </HeadingText>
          </HeadingCard>

          <ChainGrid>
            {CHAINS.map((chain) => (
              <Card key={chain.id} chain={chain} onCopy={handleCopy} />
            ))}
          </ChainGrid>
        </Content>
      </Page>

      {toastVisible && (
        <ToastContainer>
          <ToastBubble>{toastText}</ToastBubble>
        </ToastContainer>
      )}
    </>
  );
}

export default App;
